import React from "react";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";

import "./index.less";
import { Button, Modal } from "antd";
import { defaultLocale } from "@/config.json";
import _ from "lodash";
import { CloseCircleOutlined } from "@ant-design/icons";
import { project, assets } from "@/config.json";
import { loadImage } from "@/utils";
interface StoreProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

interface OtherLinkProps {
  visible: boolean;
  onCloseModal: Function;
}

interface Props extends StoreProps, OtherLinkProps {}

const mapUrl = {
  ZH: "http://e8th71bpjt78s3lx.mikecrm.com/whcoXh4?utm_source=kuangchi&utm_medium=qiantai",
  EN: "http://e8th71bpjt78s3lx.mikecrm.com/whcoXh4?utm_source=kuangchi&utm_medium=qiantai",
};

@inject("session", "locale", "router")
@observer
class OtherLink extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }
  state = {
    linkImage: "",
  };

  componentDidMount() {
    loadImage(assets.notice).then((asset) => {
      this.setState({
        linkImage: asset.default,
      });
    });
  }

  cancleModal = () => {
    this.props.onCloseModal();
  };

  render() {
    const { locale, session, visible } = this.props;
    const { linkImage } = this.state;
    const defaultMapUrl = _.get(mapUrl, mapUrl[defaultLocale], mapUrl.EN);
    return (
      <Modal
        visible={visible}
        className="modal-container"
        centered
        footer={null}
        closable={false}
        onCancel={this.cancleModal}
      >
        <img src={linkImage} className="link-image" />
        <h3>比特币爱好者集结！</h3>
        <p>一起探索比特币的奥秘</p>
        <p>只差你啦！</p>
        <Button
          type="primary"
          shape="round"
          size="large"
          target="_blank"
          href={defaultMapUrl}
          className="link-button"
          onClick={this.cancleModal}
        >
          立即参与
        </Button>
        <CloseCircleOutlined className="cancle-icon" onClick={this.cancleModal} />
      </Modal>
    );
  }
}

export default OtherLink as React.ComponentType<OtherLinkProps>;
